import { lazy } from 'react';

const GeneralSimulationStartPage = lazy(() => import('../pages/StartPage'));
const GeneralSimulationRunningPage = lazy(() => import('../pages/Running'));
const GeneralSimulationFeedbackPage = lazy(() => import('../pages/Feedback'));

export const GeneralSimulationRoutes = [
  {
    path: 'start',
    element: <GeneralSimulationStartPage />,
  },
  {
    path: 'running/:simulationId',
    element: <GeneralSimulationRunningPage />,
  },
  {
    path: 'feedback/:simulationId/:tryNumber',
    element: <GeneralSimulationFeedbackPage />,
  }
];
